import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const getTable = async (code) => {
  const response = await axios.get(routes.getTable(code), AXIOS_DEFAULT_CONFIG);
  return response;
};
export default getTable;
